/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-06-14 17:38:42
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-06-28 12:00:33
 * @FilePath: \front_admin\src\store\info.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue"
import {
  isHiddenPhone
} from '@libs/http/vuex_http'



export let info = {
  namespaced: true,
  state: {
    skinName: '',
    _radio: null, // '0':'1'
    timestamp: new Date().getTime() - 0 + 1800000
  },
  getters: {
    radio: state => state.radio,
    getSkinName: state => state.skinName || '绀青', //默认皮肤
  },
  mutations: {
    changeSkin(state, data) {
      state.skinName = data
    },
    changeHiddenStatus(state, data) {
      state._radio = data
    },
  },
  actions: {
    actionSkinChange({
      commit,
      getters
    }, res) {
      commit('changeSkin', res)
    },
    httpForIsHiddenPhone({
      commit,
      getters
    }) {
      isHiddenPhone(Vue).then(res => {
        if (res.data.code == '0') {
          //  是否隐藏  true 需要隐藏电话号码中间四位false 无需隐藏
          commit('changeHiddenStatus', res.data.data ? '0' : '1')
        }
      })
    }
  }
}
